import React, { Component } from 'react'

// lib

// redux
import { connect } from 'react-redux'

import GridContainer from '../../componentsMaterial/Grid/GridContainer.jsx'
import GridItem from '../../componentsMaterial/Grid/GridItem.jsx'
import Button from '../../componentsMaterial/CustomButtons/Button.jsx'
import ButtonAntd from '../../components/uielements/button'

import Card from '../../componentsMaterial/Card/Card.jsx'
import CardBody from '../../componentsMaterial/Card/CardBody.jsx'
import CardHeader from '../../componentsMaterial/Card/CardHeader.jsx'
import withStyles from '@material-ui/core/styles/withStyles'
import Tooltip from '@material-ui/core/Tooltip'
import CardFooter from '../../componentsMaterial/Card/CardFooter.jsx'

import AccessTime from '@material-ui/icons/AccessTime'
import Delete from '@material-ui/icons/Delete'
import ArtTrack from '@material-ui/icons/ArtTrack'
import dashboardStyle from './dashboardStyle'
import eventActions from '../../redux/event/actions'
import moment from 'moment'
import ContentHolder from '../../components/utility/contentHolder'

import Tags from '../../components/uielements/tag'
import TagWrapper from './tag.style'
import EditEvent from './Modal_edit_event'
import userActions from '../../redux/user/actions'
import RemoveEvent from './modal_removeEvent'
import CreateNewEvent from './Modal_create_new_event'
import classnames from 'classnames'
import { FaPlusCircle } from 'react-icons/fa'
import { Alert } from 'antd'
import Clearfix from '../../componentsMaterial/Clearfix/Clearfix.jsx'
import { Empty, DatePicker, Menu, Dropdown, Icon } from 'antd'
import Pagination from '../../components/uielements/pagination'

import { Input } from 'antd'
import priceImage1 from '../../resource/image/imgEventDefaul.jpg'

const { Search } = Input

const { MonthPicker, RangePicker } = DatePicker

// subcomponent
const Tag = props => (
    <TagWrapper>
        <Tags {...props}>{props.children}</Tags>
    </TagWrapper>
)
class EventManagement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currentPage: 1,
            TextSearch: '',
            begin_time: 0,
            end_time: 0,
            type_search: '',
            display_type: 'Toàn bộ trường dữ liệu',
            range_time: []

        }
    }

    componentDidMount() {
        const loadType = eventActions.loadType.GET_NOT_DELETED
        this.props.loadListEvent(1, 9, loadType)
        console.log('this.props.match.params.id', this.props.match)
        if (this.props.match.params.id) {
            this.props.getEventById(this.props.match.params.id)
        }
    }
    getRandomInt = max => {
        return Math.floor(Math.random() * Math.floor(max))
    }
    getColorTag = () => {
        const color = [
            '#f50',
            '#2db7f5',
            '#87d068',
            '#108ee9',
            '#e6f542',
            '#f54242',
        ]
        const index = this.getRandomInt(color.length)

        return color[index]
    }
    onChange(pageNumber) {
        const loadType = eventActions.loadType.GET_NOT_DELETED
        console.log("this.state.type_search", this.state.type_search)
        if (this.state.TextSearch == '' && this.state.begin_time == 0 && this.state.end_time == 0 && this.state.type_search == '') {
            console.log('Page: ', pageNumber)
            this.props.loadListEvent(pageNumber, 9, loadType)
            this.setState({ currentPage: pageNumber })
        } else {
            this.setState({ currentPage: pageNumber })
            this.props.searchEventByText(pageNumber, 9, this.state.TextSearch, loadType, this.state.begin_time, this.state.end_time, this.state.type_search)
        }

    }
    onChangeTextSearch = value => {
        const loadType = eventActions.loadType.GET_NOT_DELETED

        this.setState({ TextSearch: value.target.value, currentPage: 1 })
        console.log('value.target.value', value.target.value)
        if (value.target.value !== '') {
            // this.props.searchEventByText(1, 9, value.target.value, loadType, this.state.begin_time, this.state.end_time, this.state.type_search)
        } else {
            const loadType = eventActions.loadType.GET_NOT_DELETED
            // this.props.loadListEvent(1, 9, loadType)
            this.setState({ begin_time: 0, end_time: 0 })
            this.setState({ range_time: [] })








        }
    }
    onSearchdata = () => {
        const loadType = eventActions.loadType.GET_NOT_DELETED
        if (this.state.TextSearch || this.state.type_search || this.state.begin_time || this.state.end_time) {
            this.props.searchEventByText(1, 9, this.state.TextSearch, loadType, this.state.begin_time, this.state.end_time, this.state.type_search)
        } else {
            this.props.loadListEvent(1, 9, loadType)
        }
    }
    onChangeTime = e => {
        this.setState({ range_time: e })
        if (e && e.length > 0) {
            const starttime = (e[0]._d.valueOf() / 1000) >> 0
            const endtime = (e[1]._d.valueOf() / 1000) >> 0
            this.setState({ begin_time: starttime, end_time: endtime })
        } else {
            this.setState({ begin_time: 0, end_time: 0 })
        }

    }

    render() {
        const { events } = this.props
        const { classes, height } = this.props
        const menu = (
            <Menu onClick={e => {
                if (e.key !== '0') {
                    this.setState({ type_search: e.key, display_type: e.item.props.children })
                } else {
                    this.setState({ type_search: '', display_type: e.item.props.children })
                }
            }}>
                <Menu.Item key="0" icon={<Icon type="user" />}>
                    Toàn bộ trường dữ liệu
                </Menu.Item>
                <Menu.Item key="TypeSearchEventHashtag" icon={<Icon type="user" />}>
                    HashTag
                </Menu.Item>
                <Menu.Item key="TypeSearchEventName" icon={<Icon type="user" />}>
                    Tên sự kiện
                </Menu.Item>
                <Menu.Item key="TypeSearchEventAddress" icon={<Icon type="user" />}>
                    Địa chỉ
                </Menu.Item>
                <Menu.Item key="TypeSearchEventDesc" icon={<Icon type="user" />}>
                    Mô tả
                </Menu.Item>
            </Menu>
        );
        return (
            <div className="OrganizationMain">
                <div
                    style={{
                        paddingLeft: 30,
                        paddingTop: 20,
                        paddingBottom: 50,
                        flexDirection: 'row',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <Button
                        color="info"
                        onClick={() => {
                            this.props.visibleModalCreateEvent(true)
                        }}
                    >
                        <FaPlusCircle />
                        Thêm mới sự kiện
                    </Button>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <RangePicker
                            format="DD/MM/YYYY"
                            renderExtraFooter={() =>
                                'Tìm kiếm trong khoảng thời gian'
                            }
                            value={this.state.range_time}
                            onChange={this.onChangeTime}
                            placeholder={[
                                'Thời gian đầu',
                                'Thời gian cuối',
                            ]}
                            showTime
                            // disabled={this.state.TextSearch === ''}

                            style={{ marginRight: 20, height: 35 }}
                        />
                        <Dropdown overlay={menu}>
                            <ButtonAntd style={{ height: 32, marginRight: 20 }}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", justifyContent: 'center' }}>
                                    <text>{this.state.display_type}</text>
                                    {/* <DownOutlined style={{ marginLeft: 10 }} /> */}
                                    <Icon style={{ marginLeft: 10 }} type="down" />
                                </div>

                            </ButtonAntd>
                        </Dropdown>

                        <Search
                            style={{ height: 35, width: 300, marginRight: 20 }}
                            placeholder="Nhập để tìm kiếm"
                            onSearch={this.onSearchdata}
                            onChange={this.onChangeTextSearch}
                        />
                    </div>
                </div>
                {events.length === 0 && !this.props.isLoading && (
                    <Empty
                        description={<span>Không có dữ liệu . . . </span>}
                    ></Empty>
                )}
                {this.props.isLoading && (
                    <Empty
                        description={<span>Đang tải dữ liệu. . . </span>}
                    ></Empty>
                )}
                {events.length > 0 && (
                    <GridContainer>
                        {events.map(data => (
                            <GridItem xs={6} sm={6} md={4} xxl={3}>
                                <Card product className={classes.cardHover}>
                                    <CardHeader
                                        image
                                        className={classes.cardHeaderHover}
                                    >
                                        <a
                                            href="#pablo"
                                            onClick={e => e.preventDefault()}
                                        >
                                            <img
                                                style={{
                                                    height: 250,
                                                }}
                                                src={
                                                    data.avatar
                                                        ? data.avatar
                                                        : priceImage1
                                                }
                                                alt="..."
                                            />
                                        </a>
                                    </CardHeader>
                                    <CardBody>
                                        <div className={classes.cardHoverUnder}>
                                            <Tooltip
                                                id="tooltip-top"
                                                title="Xem chi tiết"
                                                placement="bottom"
                                                classes={{
                                                    tooltip: classes.tooltip,
                                                }}
                                            >
                                                <Button
                                                    color="success"
                                                    simple
                                                    justIcon
                                                    onClick={() => {
                                                        this.props.getEventById(
                                                            data.event_id
                                                        )
                                                        // this.props.getCurrentUser(
                                                        //     data.owner_id
                                                        // )
                                                    }}
                                                >
                                                    <ArtTrack
                                                        className={
                                                            classes.underChartIcons
                                                        }
                                                    />
                                                </Button>
                                            </Tooltip>
                                            <Tooltip
                                                id="tooltip-top"
                                                title="Xoá sự kiện"
                                                placement="bottom"
                                                classes={{
                                                    tooltip: classes.tooltip,
                                                }}
                                            >
                                                <Button
                                                    color="danger"
                                                    simple
                                                    justIcon
                                                    onClick={() => {
                                                        this.props.visibleModalRemoveEvent(
                                                            true,
                                                            data.event_id
                                                        )
                                                    }}
                                                >
                                                    <Delete
                                                        className={
                                                            classes.underChartIcons
                                                        }
                                                    />
                                                </Button>
                                            </Tooltip>
                                        </div>
                                        <h4
                                            className={classes.cardProductTitle}
                                        >
                                            <a
                                                href="#pablo"
                                                onClick={e =>
                                                    e.preventDefault()
                                                }
                                            >
                                                {data.name}
                                            </a>
                                        </h4>
                                        <p
                                            className={
                                                classes.cardProductDesciprion
                                            }
                                        >
                                            {data.content.length < 150
                                                ? data.content
                                                : data.content.slice(0, 150) +
                                                '...'}
                                        </p>
                                    </CardBody>

                                    <CardFooter product>
                                        <div className={classes.price}>
                                            <AccessTime
                                                style={{ paddingRight: 5 }}
                                            />
                                            <h8>
                                                {moment(
                                                    data.begin_time * 1000
                                                ).format('DD/MM/YYYY')}
                                            </h8>
                                            {' - '}
                                            <h8>
                                                {moment(
                                                    data.end_time * 1000
                                                ).format('DD/MM/YYYY')}
                                            </h8>
                                            <ContentHolder>
                                                {data.hashtag.map(value => (
                                                    <Tag
                                                        color={this.getColorTag()}
                                                    >
                                                        {value}
                                                    </Tag>
                                                ))}
                                                <Clearfix />
                                            </ContentHolder>
                                        </div>
                                    </CardFooter>
                                    {/* <CardFooter profile>
                                       
                                    </CardFooter> */}
                                </Card>
                            </GridItem>
                        ))}
                        <div
                            style={{
                                marginBottom: 30,
                                width: '100%',
                                textAlign: 'center',
                            }}
                        >
                            <Pagination
                                onChange={pageNumber =>
                                    this.onChange(pageNumber)
                                }
                                current={this.state.currentPage}
                                total={this.props.totalEvent}
                                pageSize={9}
                            />
                        </div>
                    </GridContainer>
                )}

                <EditEvent />
                <RemoveEvent />
                <CreateNewEvent />
                <br />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        events: state.eventReducer.events,
        totalEvent: state.eventReducer.totalEvent,
        isLoading: state.eventReducer.isLoading,
        ...state.app,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadListEvent: (page_number, page_size, loadType) => {
            dispatch(
                eventActions.action.getListEvent(
                    page_number,
                    page_size,
                    loadType
                )
            )
        },
        visibleModalEditEvent: isvisible => {
            dispatch(eventActions.action.visibleEditModal(isvisible))
        },
        visibleModalRemoveEvent: (isvisible, eid) => {
            dispatch(eventActions.action.visibleRemoveModal(isvisible, eid))
        },
        visibleModalCreateEvent: isvisible => {
            dispatch(eventActions.action.visibleCreateModal(isvisible))
        },
        getEventById: eid => {
            dispatch(eventActions.action.getEventById(eid))
        },
        getCurrentUser: uid => {
            dispatch(userActions.action.getCurrentUser(uid))
        },
        searchEventByText: (page_number, page_size, text, status, begin, end, type_search) => {
            dispatch(
                eventActions.action.searchEventByText(
                    page_number,
                    page_size,
                    text,
                    status,
                    begin,
                    end,
                    type_search
                )
            )
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(dashboardStyle)(EventManagement))
